import { TableCell, TableRow } from '@mui/material'
import { FunctionComponent } from 'react'
import { IGeneratedSecrReportResponse } from '../../../../shared/services/generated-report/generated-report.model'

export const ReportingSecrTableHeading: FunctionComponent<{ title: string, report: IGeneratedSecrReportResponse, includeTopBorder?: boolean }> = ({ title, report, includeTopBorder = true }) => {
  const cellSx = {
    fontWeight: 700,
    color: 'common.black',
    wordBreak: 'break-word' as const,
    overflowWrap: 'anywhere' as const,
    borderBottomColor: 'primary.dark',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderTopColor: 'primary.dark',
    borderTopWidth: '2px',
    borderTopStyle: includeTopBorder ? ('solid' as const) : ('none' as const),
    py: 0.65,
  };
  return (
    <TableRow>
      <TableCell scope='row' sx={cellSx}>
        {title}
      </TableCell>
      <TableCell align="center" sx={{
        ...cellSx,
      }}></TableCell>
      {report.includeGlobal && <>
        <TableCell align="center" sx={cellSx}></TableCell>
        <TableCell align="center" sx={cellSx}></TableCell>
      </>}
      {report.reportDetails.filter(value => !value.isPrimaryReportPeriod).map((value, index) => {
        return <>
          <TableCell key={index} align="center" sx={cellSx}></TableCell>
          {report.includeGlobal && <>
            <TableCell key={index} align="center" sx={cellSx}></TableCell>
            <TableCell key={index} align="center" sx={cellSx}></TableCell>
          </>}
        </>
      })}
    </TableRow>
  )
}